import './sub-header.css'
import React from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import paths from "../../paths";
import unitedRacingIcon from "../../assets/icons/united-racing.svg"
import esansIcon from "../../assets/icons/esans-icon.png"
import milliPiyangoIcon from "../../assets/icons/milli-piyango-icon.svg";
import sanalOyunIcon from "../../assets/icons/sanal-oyunlar-icon.svg";
import newBadge from "../../assets/img/new-badge.png";
import scratchIcon from "../../assets/icons/kazi-kazan.svg"
import cekilisIcon from "../../assets/icons/cekilis.svg";
import oyunlarIcon from "../../assets/icons/oyunlar.svg";
import donusturIcon from "../../assets/img/donustur-2.png";
import vrhorseracingIcon from "../../assets/icons/vr-horse-racing-icon.svg";
import {env} from "../../constants/global.vars";

type SubItem = {
    title: string
    path: any
    isNew?: boolean
    icon?: React.ReactNode
}

type MenuItem = {
    title: string
    icon?: React.ReactNode
    border: string
    path?: any
    isNew?: boolean
    seperator?: boolean
    sub_items?: SubItem[]
}

const items: MenuItem[] = [
    {
        title: 'At Yarışı',
        icon: <img width={20} src={unitedRacingIcon} alt={"united"}/>,
        border: '#FFFFFF',
        sub_items: [
            {title: 'Müşterek Bahis', path: paths.betting},
            {title: 'Sabit İhtimalli Bahis', path: paths.fobBetting},
            {title: 'Uzun Vadeli Bahis', path: paths.longtermBetting, isNew: true},
            {title: 'Program', path: paths.program},
            {title: 'Uzman Yorumları', path: paths.tipsterComments},
            {title: 'Sonuçlar', path: paths.results},
            {title: 'Hazır Kuponlar', path: paths.tipsterCoupons},
            {title: 'Kampanyalar', path: paths.campaigns},
        ]
    },
    {
        title: 'Sanal Oyunlar',
        icon: <img width={30} src={sanalOyunIcon} alt={"sanal-oyunlar"}/>,
        border: '#FFFFFF',
        path: paths.vrgames,
        isNew: false
    },
    {
        title: 'Sayısal Oyunlar',
        icon: <img width={30} src={milliPiyangoIcon} alt={"sayisal-oyunlar"}/>,
        border: '#FFFFFF',
        path: paths.numericgames,
        isNew: false
    },
    {
        title: 'Kazı Kazan',
        icon: <img width={30} height={28} src={scratchIcon} alt="kazi-kazan" style={{filter: "brightness(0) invert(1)"}}/>,
        border: '#FFFFFF',
        path: paths.sisalscratch,
        isNew: true,
    },
    {
        title: 'Şans Oyunları',
        border: '#FFFFFF',
        path: paths.games,
        icon: <img width={30} src={esansIcon} alt={"sans-oyunlari"}/>,
        seperator: true,
        sub_items: [
            {
                title: 'Dijital Oyunlar',
                path: paths.games,
                icon: <img width={25} src={oyunlarIcon} alt={"dijital-oyunlar"} style={{filter: "brightness(0) invert(1)"}}/>
            },
            {
                title: 'Eşya Piyangosu',
                path: paths.raffles,
                icon: <img width={25} src={cekilisIcon} alt={"esya-piyangosu"} style={{filter: "brightness(0) invert(1)"}}/>
            },
            // {title: 'Puan Dönüştür', path: paths.products, isNew: true, icon: <img width={35} src={donusturIcon} alt={"puan-donustur"}/>},
        ]
    },
]

if (env.isTest) {
    items.push({
        title: 'Sanal At Yarışı',
        icon: <img width={25} height={25} src={vrhorseracingIcon} alt="sanal-at-yarisi" style={{filter: "brightness(0) invert(1)"}}/>,
        border: '#FFFFFF',
        path: paths.vrhorseracing,
        isNew: true,
    })
}

export function SubHeader() {
    const location = useLocation();
    const navigate = useNavigate();

    const active = items.find(it =>
        (it.path && location.pathname.startsWith(it.path.url))
        || it.sub_items?.some(si => location.pathname.startsWith(si.path.url))
    ) ?? items[0];
    const subItemsOwner = active ?? (location.pathname === '/' ? items[0] : null);
    const subItems = subItemsOwner?.sub_items;

    return (
        <div className={"container"}>
            <div className={"sub-header"}>
                <div className={"sub-header-items"}>
                    {items.map((el, key) => el.sub_items ? (
                        <div key={`sub-header-item-${key}`} className={"sub-header-item"} onClick={() => {
                            if (el.sub_items) {
                                navigate(el.sub_items[0].path.url);
                            }
                        }}
                             style={{
                                 backgroundColor: active === el ? '#2f3da8' : "transparent",
                                 border: active === el ? "1px solid transparent" : `1px solid ${el.border}`
                             }}>
                            {el.icon}
                            <span>{el.title}</span>
                            <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 0.75L4.75 4.75L8.75 0.75" stroke="white" stroke-width="1.5"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    ) : (
                        <Link key={`sub-header-item-${key}`} to={el.path.url}
                              className={"sub-header-item"}
                              style={{
                                  backgroundColor: active === el ? '#2f3da8' : "transparent",
                                  border: active === el ? "1px solid transparent" : `1px solid ${el.border}`,
                                  position: 'relative'
                              }}>
                            {el.isNew && (
                                <div className={"new-badge"} style={{left: -20}}>
                                    <img src={newBadge}/>
                                </div>
                            )}
                            {el.icon}
                            <span>{el.title}</span>
                        </Link>
                    ))}
                </div>

                {subItems && subItems.length > 0 && (() => {
                    const activeSub = subItems
                        .filter((si: any) => location.pathname.startsWith(si.path.url))
                        .sort((a: any, b: any) => b.path.url.length - a.path.url.length)[0]
                    const addSeperator = active.seperator ?? false;

                    return (
                        <div className={"sub-header-sub-items" + (addSeperator ? " has-seperator" : "")}>
                            {subItems.map((el: any, key: number) => (
                                <div key={`sub-header-sub-item-${key}`} className={"sub-header-sub-item"} style={{position: 'relative'}}>
                                    <Link to={el.path.url}
                                          className={"sub-nav-item" + (el === activeSub ? " active" : "")}>
                                        {el.isNew && (
                                            <div className={"new-badge"} style={{left: -20}}>
                                                <img src={newBadge}/>
                                            </div>
                                        )}
                                        {el.icon}
                                        {el.title}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    );
                })()}
            </div>
        </div>
    )
}